import { render, staticRenderFns } from "./XFormInput.vue?vue&type=template&id=79c1219a&"
import script from "./XFormInput.vue?vue&type=script&lang=js&"
export * from "./XFormInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports